/* This code was auto-generated **DO NOT EDIT**
 * If you need to make changes to this file please refer to README.md
 */

import React, { forwardRef } from "react";
import { oneOf, string } from "prop-types";

import componentSizes from "../../constants/componentSizes";
import CalendarLG from "../assets/brand/LG/calendar.svg";
import CalendarMD from "../assets/brand/MD/calendar.svg";
import CalendarSM from "../assets/brand/SM/calendar.svg";
import * as S from "../styled";

const CalendarIconAssets = {
  [componentSizes.LG]: CalendarLG,
  [componentSizes.MD]: CalendarMD,
  [componentSizes.SM]: CalendarSM
};

const CalendarIcon = forwardRef(
  ({ className, size, ...passThroughProps }, ref) => (
    <S.Icon
      ref={ref}
      className={className}
      src={CalendarIconAssets[size]}
      {...passThroughProps}
    />
  )
);

CalendarIcon.propTypes = {
  className: string,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

CalendarIcon.defaultProps = {
  className: "",
  size: componentSizes.MD
};

export default CalendarIcon;
